import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'
import { RichTextWrapper } from '../../../styles/global'

//* utils
import ImgUtil from '../../../utils/img.utils'
import { internalLinkHandler } from '../../../utils/link.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type Props = {
  property: any
  item: any
  iconTextData: any
}

export const IconText: FC<Props> = ({ property, item, iconTextData }) => {
  const whiteIconUrl = item.whiteIcon?.file?.url || ''
  const colorIconUrl = item.colorIcon?.file?.url || ''

  const fullWidth = iconTextData.useCase === 'Full width' || ''
  const isLightOrGray = iconTextData.theme === 'Light' || iconTextData.theme === 'Grey'
  const iconCtaUrl = item.iconCta?.internalLink
    ? internalLinkHandler(item.iconCta.internalLink)
    : item.iconCta?.externalUrl || ''

  let icon = ''
  if (fullWidth) {
    icon = colorIconUrl
  } else if (iconTextData.theme === 'Dark' && whiteIconUrl) {
    icon = whiteIconUrl
  } else if (isLightOrGray && colorIconUrl) {
    icon = colorIconUrl
  }

  return (
    <Grid item {...property} className="Icons__Item-Container" data-cy="icons__Item-Container">
      {icon && (
        <WrapperImage
          src={ImgUtil.getResizedImageUrl(icon, `width=64`)}
          alt="icon"
          threshold={650}
        />
      )}

      <div className="Icons__Text-Container">
        {item.title && (
          <Typography className="Icons__Title" type="label">
            {formatInlineCode(item.title)}
          </Typography>
        )}

        {item.body && <RichTextWrapper $type="body">{renderRichText(item.body)}</RichTextWrapper>}

        {item.iconCta?.text && iconCtaUrl && (
          <Button
            icon={true}
            href={iconCtaUrl}
            text={item.iconCta.text}
            type="text-link"
            size="small"
            className="Icon__CTA"
            theme={iconTextData.theme === 'Dark' ? 'dark' : 'light'}
          />
        )}
      </div>
    </Grid>
  )
}
